import Helper from './Helper';

class ScrollToTop {
  constructor(config = {}) {
    const {
      buttonSelector
    } = config;
    this.buttons = document.querySelectorAll(buttonSelector);
    this.buttonsArray = Array.prototype.slice.call(this.buttons);
    this.currentScrollPosition = window.scrollY;

    if (this.buttons.length > 0) {
      this.bindEvents();
    }
  }

  bindEvents(){
    if (this.currentScrollPosition > 100) {
      this.buttonsArray.forEach((button, i) => {
        Helper.addClass(button, 'show');
      });
    }

    window.addEventListener('scroll', (e) => {
      if ( window.scrollY > 100) {
        this.buttonsArray.forEach((button, i) => {
          Helper.addClass(button, 'show');
        });
      } else {
        this.buttonsArray.forEach((button, i) => {
          Helper.removeClass(button, 'show');
        });
      }
    });

    this.buttonsArray.forEach((button, i) => {
      button.addEventListener('click', (e) => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    });
  }

}

export default ScrollToTop;
